import { useQuery } from '@tanstack/react-query';

import { AuthorizationRequestType, FlightOperationNotificationClient, FlightOperationNotification, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightOperationNotificationClient = new FlightOperationNotificationClient(apiBaseUrl);

function useGetFlightOperationNotificationReport(id: number, role: AuthorizationRequestType) {
  return useQuery<FlightOperationNotification, ProblemDetails>({
    queryKey: [queryKeys.FlightOperationNotification.Get, { id }],
    queryFn: () => flightOperationNotificationClient.get(id, role),
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export default useGetFlightOperationNotificationReport;
